module.exports = __webpack_public_path__ + "static/media/henta.e5c8860e.m4a";